import { React, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import Loader from "../../components/loader";
import Logo from "../../components/logo";

// constants
import { ROUTES } from "../../constants";

// hooks
import useFetchHandler from "../../hooks/use-fetch-handler";

export default function StaffSelectPage(props) {
    const { onStaffSelect } = props;
    const navigate = useNavigate();
    const [staffList, setStaffList] = useState([]);
    const [selectedId, setSelectedId] = useState(null);

    const { loading, error, handleFetch } = useFetchHandler();

    const fetchStaffList = useCallback(async () => {
        await handleFetch(
            "GET",
            "clinic/staffs",
            null,
            true,
            (data) => {
                setStaffList(data?.data || []);
            }
        );
    }, [handleFetch]);

    useEffect(() => {
        fetchStaffList();
    }, [fetchStaffList]);

    const handleStaffSelect = useCallback((staffId) => {
        setSelectedId(staffId);
        localStorage.setItem("staffId", staffId);
        onStaffSelect();
        setTimeout(() => {
            navigate(ROUTES.HOME);
        }, 200);
    }, [navigate, onStaffSelect]);

    const handleLogout = useCallback(() => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("expires_at");
        localStorage.removeItem("staffId");
        window.location.href = ROUTES.LOGIN;
    }, []);

    if (loading) {
        return <Loader message={"Loading staff, "} />;
    }

    return (
        <main className="flex-grow flex flex-col items-center p-10 gap-10">
            <Logo />
            <h1 className="text-xl font-semibold text-center">Select Staff</h1>
            {error && (
                <p className="text-center text-red-500 font-bold">{error}</p>
            )}
            <div className="w-full flex flex-col gap-3 max-w-md">
                {staffList.map((staff) => (
                    <button
                        key={staff.id}
                        className={`w-full px-6 py-4 rounded-lg text-lg font-medium text-left transition-colors ${
                            selectedId === staff.id
                                ? "bg-accent-1 text-white"
                                : "bg-text-1 text-background-1"
                        }`}
                        onClick={() => handleStaffSelect(staff.id)}
                    >
                        {staff.name}
                    </button>
                ))}
            </div>
            <footer className="mt-auto w-full flex items-center justify-center">
                <button
                    className="bg-text-1 text-background-1 font-semibold text-base w-[225px] py-2 text-center rounded"
                    onClick={handleLogout}
                >
                    Log out
                </button>
            </footer>
        </main>
    );
}
